import React, { useEffect } from "react";
import { Container, Grid, Typography, Box, Stack } from "@mui/material";
import "./Contact.css";


export default function Contact() {
  
  return (
    <div style={{ marginTop: "90px" }}>
      <Container>
        <Grid
          container
          style={{
            // backgroundColor: "blue",
            justifyContent: "center",
            alignItems: { xs: "center" },
            marginTop: "10px",
          }}
        >
          <Grid
            item
            style={{}}
            xs={12}
            md={8}
            sx={{
              marginTop: { md: "80px", xs: "20px" },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "gray",
                fontWeight: 500,
                fontFamily: "Getboreg Trial Only",
                textAlign: "center",
                marginBottom: { md: "100px", xs: "70px" },
                fontSize: { xs: "15px", md: "20px" },
              }}
            >
              W H A T N E X T
            </Typography>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              data-aos="flip-up"
              data-aos-duration="5000"
              className="textcontainer"
            >
              <Typography
                sx={{
                  color: "#00adb5",
                  fontWeight: 500,
                  fontFamily: "g Game TC",
                  textAlign: "center",
                  fontSize: { md: "50px", xs: "25px" },
                }}
                variant="h3"
                className="luminance"
              >
                Contact
              </Typography>
              <Box
                style={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: "#00adb5",
                  borderRadius: "50%",
                }}
              ></Box>
            </Stack>
            <Box
              marginTop="20px"
              data-aos="fade-right"
              data-aos-duration="5000"
            >
              <Typography
                color="white"
                style={{
                  fontFamily: "Titillium Web",
                  fontWeight: "400",
                  letterSpacing: "1px",
                  textAlign: "center",
                }}
              >
                Thank you for visiting my portfolio! If you have any questions
                regarding my works, please feel free to reach out to me.
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            container
            sx={{
              alignItems: "center",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <Grid item data-aos="flip-up">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="mailto:th4rinonline@gmail.com"
              >
                <button class="button">
                  <span class="text" style={{ fontFamily: "Titillium Web" }}>
                    send message
                  </span>
                  <span class="icon">
                    <svg
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      data-icon="paper-plane"
                      width="20px"
                      aria-hidden="true"
                    >
                      <path
                        d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
